module.exports = __webpack_public_path__ + "img/voice.2ede4005.svg";